import React from 'react';
import { useMsal } from '@azure/msal-react';
import { useDispatch } from 'react-redux';
import { loginRequest } from '../../auth/authConfig';
import { setAuthSuccess } from '../../redux/auth/authSlice';
import logoConstellation from '../../assets/Logo_ConstellationV2.png';
import { Button } from '../ui';
import { LoginContainer, LoginCard } from './appShell.styled';

export default function LoginScreen() {
    const { instance } = useMsal();
    const dispatch = useDispatch();

    const handleLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);
            if (response && response.accessToken) {
                dispatch(setAuthSuccess(response.accessToken));
            }
        } catch (e) {
            console.error('Erreur lors de la connexion :', e);
        }
    };

    return (
        <LoginContainer>
            <LoginCard>
                <img src={logoConstellation} alt="Constellation" />
                <p>Gestion des utilisateurs, appareils et groupes Microsoft 365 du groupe Constellation.</p>
                <Button onClick={handleLogin}>
                    <i className="bx bx-log-in" />
                    Se connecter avec Microsoft
                </Button>
            </LoginCard>
        </LoginContainer>
    );
}
